import { getCurrentInstance, Ref, ToRefs, toRefs,  WritableComputedRef, App } from 'vue'
import service from '@workspace/sab-core/data/service'
import { Currency } from '@workspace/sab-core/domain/model/basics'
import { HotelEntity } from '@workspace/sab-core/domain/model/hotel'

const KEY = Symbol('config')

export function initializeAPIs () {
  /* set content API path */
  const contentApiURL = process.env.VUE_APP_CONTENT_API_URL || ''
  service.setContentApiPath(contentApiURL + '/')

  /* set Elasticsearch API path */
  const esApiURL  = process.env.VUE_APP_ELASTICSEARCH_URL || ''
  service.setElasticsearchApiPath(esApiURL + '/')

  /* set addaJet API path */
  const addaJetApiURL  = process.env.VUE_APP_ADDAJET_URL || ''
  service.setAddaJetApiPath(addaJetApiURL + '/')
}

export interface RawAppState {
  /* Application global state */
  checkin?: Date | undefined
  checkout?: Date | undefined
  currency?: Currency | undefined
  promocode?: string
  isStage?: boolean
  elasticIndices: Record<string, string>
  hotelContentItems?: HotelEntity[]
}

export type AppState = ToRefs<RawAppState> & {
  locale: Ref<string>
}

export function createAppState(
  v: RawAppState,
  locale: WritableComputedRef<string>
) {
  const global: AppState = Object.assign(toRefs(v), {
    locale
  })

  return {
    global,
    install: (app: App) => {
      app.provide(KEY, global)
    }
  }
}

/**
 * Tries to retrieve app state if it was initialized. Throws otherwise
 * @throws {Error}
 * @see {@link initializeAppState}
 */
export function useAppState (): AppState {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('[template-commons] Application instance is not defined, please use this method inside `setup`')
  }

  const providedState: AppState | undefined = instance.appContext.provides[KEY]
  if (!providedState) {
    throw new Error('[template-commons] State is uninitialized. Are you sure you registered the plugin correctly?')
  }

  return providedState
}
